import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MessageSquareQuoteIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Las 12 semanas me cambiaron la perspectiva. No es magia: es el sistema y Matías sosteniéndome cuando quería aflojar.',
  name: 'Alejandro',
  location: 'Argentina'
}, {
  quote: 'Por fin entendí por qué estaba trabada. Trabajando uno a uno con Mati, hizo clic algo que venía evitando hace años.',
  name: 'Cynthia',
  location: 'Perú'
}, {
  quote: 'Lo más fuerte no fue lo que cambié en mí, fue lo que cambió en mi casa. Mis hijos notaron que estaba presente de verdad.',
  name: 'Jose',
  location: 'México'
}, {
  quote: 'Tomo decisiones en horas, no en semanas. Dejé de dudar de mí en cada paso. Eso solo vale las 12 semanas.',
  name: 'Liliana',
  location: 'USA'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-336" data-mp="32fhnzbea2f3f">
      <div className="max-w-6xl mx-auto px-6" data-id="element-337" data-mp="2uzrlxb4kptot">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-338" data-mp="2q3152lky2u2c">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-339" data-mp="2q0evyhieo6i0">
            Lo que dicen quienes ya lo hicieron
          </h2>
          <p className="text-offwhite-dim text-lg" data-id="element-340" data-mp="2zs16ebmx61jp">
            Resultados reales de personas reales.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-341" data-mp="2c38ecq9f4dud">
          {TESTIMONIALS.map((item, idx) => <FadeIn key={item.name} delay={idx * 0.1} direction="up" className="bg-charcoal p-6 md:p-8 rounded-sm border border-charcoal-light relative flex flex-col" data-id="element-342" data-mp="275ghdhtx21jb" data-mpi={idx}>
              <MessageSquareQuoteIcon className="absolute top-6 right-6 w-8 h-8 text-sand/20" data-id="element-343" data-mp="1af3q6rkys0f" />
              <p className="text-base md:text-lg text-offwhite-dim italic leading-relaxed relative z-10 pr-10" data-id="element-344" data-mp="3sh8d3xwj1xg1">
                "{item.quote}"
              </p>
              <div className="mt-auto pt-6 flex items-center gap-3" data-id="element-345" data-mp="3eitkajy4uhp">
                <div className="w-10 h-10 bg-charcoal-dark rounded-full border border-charcoal-light flex items-center justify-center shrink-0" data-id="element-346" data-mp="8cu30k6bx2ze">
                  <span className="text-sand font-heading font-bold text-sm" data-id="element-347" data-mp="db3ykvvyu5lj">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-348" data-mp="3gv8b8v78ve0h">
                  <span className="text-sm text-offwhite font-medium block" data-id="element-349" data-mp="3grkhpw1surlr">
                    {item.name}
                  </span>
                  <span className="text-xs text-offwhite-dim/60 uppercase tracking-wider" data-id="element-350" data-mp="3qrbbfvijd2ks">
                    {item.location}
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}